import { useState } from 'react'
import { ArrowRight } from 'lucide-react'
import { BandReveal, InteractiveDots, ScrollReveal, TextReveal } from '@/components/motion'

/**
 * Newsletter band in the reference's "Sector news. Proven cases. Zero
 * noise." layout: full-bleed purple with the interactive halftone field
 * thickening to the right, huge white uppercase display whose last word
 * drops to a lighter tint, quote-bar lede, translucent display-face email
 * field and a white boxy submit.
 *
 * No backend yet: a submitted address flips to a confirmation line. Wire the
 * handler to the marketing endpoint when one exists.
 */
export function SubscribeBand() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)

  return (
    <BandReveal>
      <section className="landing-section relative overflow-hidden bg-[var(--color-landing-secondary)]">
        <InteractiveDots interactive />
        <div className="landing-container relative z-10">
          <div className="max-w-4xl">
            <TextReveal
              as="h2"
              className="landing-text-display-xl text-white mb-10"
              lines={[
                'Product news. Proven',
                <>
                  templates. Zero <span className="text-white/70">noise.</span>
                </>,
              ]}
            />

            <ScrollReveal direction="none" delay={0.15}>
              <p className="landing-text-body-sm text-white/85 border-l border-white/40 pl-4 max-w-xs mb-10">
                Template drops, agent recipes and real customer results,
                delivered to your inbox.
              </p>
            </ScrollReveal>

            <ScrollReveal direction="none" delay={0.25}>
              {submitted ? (
                <p className="font-[family-name:var(--font-landing-display)] uppercase text-lg text-white">
                  You&apos;re on the list. Talk soon.
                </p>
              ) : (
                <form
                  className="flex flex-col sm:flex-row gap-3 max-w-2xl"
                  onSubmit={(e) => {
                    e.preventDefault()
                    if (email.trim()) setSubmitted(true)
                  }}
                >
                  <label htmlFor="subscribe-email" className="sr-only">
                    Your work email
                  </label>
                  <input
                    id="subscribe-email"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Your work email"
                    className="h-16 flex-1 bg-white/20 backdrop-blur-xl border-0 px-5 font-[family-name:var(--font-landing-display)] text-sm uppercase text-white placeholder:text-white/60 rounded-none outline-none focus-visible:ring-2 focus-visible:ring-white"
                  />
                  <button
                    type="submit"
                    className="landing-cta landing-cta--md landing-btn-sweep h-16 bg-white text-[var(--color-landing-primary)] hover:text-white"
                  >
                    Subscribe now
                    <ArrowRight className="h-4 w-4" />
                  </button>
                </form>
              )}
            </ScrollReveal>
          </div>
        </div>
      </section>
    </BandReveal>
  )
}

export default SubscribeBand
